.discord-embed .discord-embed-fields {
	display: grid;
	grid-column: 1/1;
	margin-top: 8px;
	grid-gap: 8px;
}
